<div #chartContainer class="chart-container"></div>